<ng-container *ngIf="section != undefined">
    <ng-template #previewHost kveBuilderHost [section]="section" [rendererComponent]="rendererComponent" [edit]="edit"></ng-template>
</ng-container>

